import { IProduct } from 'interfaces/IProduct'
import BaseAutocomplete from './baseAutocomplete'
import { VALUE_BARANG_JADI } from 'enums/stockCard'
import { Department } from 'enums/department'
import { formatDecimalAuto } from 'shared/numberFormatter'

const headers = [
  {
    id: 'productName',
    numeric: false,
    disablePadding: true,
    label: 'Nama',
    width: 'medium',
  },
  {
    id: 'packagingId',
    numeric: false,
    disablePadding: false,
    label: 'Kemasan',
    width: 'medium',
  },
  {
    id: 'weight',
    numeric: false,
    disablePadding: false,
    label: 'Berat',
    width: 'small',
  },
  {
    id: 'unitPrice',
    numeric: false,
    disablePadding: false,
    label: 'Harga',
    width: 'small',
    isPrice: true,
  },

  {
    id: 'brandId',
    numeric: false,
    disablePadding: false,
    label: 'Merek',
    width: 'small',
  },
  {
    id: 'halal',
    numeric: false,
    disablePadding: false,
    label: 'Halal',
    width: 'tiny',
    isCheckbox: true,
  },
  {
    id: 'box',
    numeric: false,
    disablePadding: false,
    label: 'Dus',
    width: 'tiny',
    isCheckbox: true,
  },
  {
    id: 'wrap',
    numeric: false,
    disablePadding: false,
    label: 'Shrink Wrap',
    width: 'tiny',
    isCheckbox: true,
  },
  {
    id: 'seal',
    numeric: false,
    disablePadding: false,
    label: 'Segel',
    width: 'tiny',
    isCheckbox: true,
  },
]

export default function LoadProductAutocomplete(props: {
  name?: string
  brandId?: string
  onChange?: (product: IProduct) => void
  disabled?: boolean
  required?: boolean
  showInactive?: boolean
  type: string
  getMatchedData?: (products: IProduct[]) => void
  showDetailedTable?: boolean
  loadAll?: boolean
  noRestrictions?: number | boolean
  department?: Department
  showProductIdColumn?: boolean
}) {
  const {
    name,
    loadAll,
    brandId,
    type,
    noRestrictions,
    department,
    showInactive,
    showProductIdColumn,
  } = props

  const productHeaders = showProductIdColumn
    ? [
        {
          id: 'productId',
          numeric: false,
          disablePadding: false,
          label: 'Product ID',
          width: 'small',
        },
        ...headers,
      ]
    : headers

  const tableHeaders = showInactive
    ? [
        ...productHeaders,
        {
          id: 'productStatus',
          numeric: false,
          disablePadding: false,
          label: 'Status',
          width: 'small',
        },
      ]
    : productHeaders

  let url = '/products/getProduct'

  const extraParams = {
    type,
    ...(noRestrictions !== undefined && {
      noRestrictions: String(noRestrictions),
    }),
    ...(department && { department }),
  }

  const responseMapper = (product: IProduct) => {
    let base = `${product.productName}`
    if (type === VALUE_BARANG_JADI) {
      base += ` | ${product.brandId}`
    } else {
      // STJ or other types: Show more technical details
      const packing = product.packagingName || product.packagingId || '-'
      const premix = product.premixId || '-'
      base = `${product.productName || 'STJ'} | Pack: ${packing} | Premix: ${premix}`
    }
    const fillingValue = product.fillingAmount
    const fillingDisplay =
      typeof fillingValue === 'number' || (typeof fillingValue === 'string' && fillingValue !== '')
        ? formatDecimalAuto(fillingValue)
        : '-'
    base += ` | Filling: ${fillingDisplay} | Batch: ${product.batchNumber || '-'}`

    return base
  }

  return (
    <BaseAutocomplete
      {...props}
      brandId={brandId}
      url={url}
      headers={tableHeaders}
      label="Produk"
      loadAll={loadAll}
      name={name}
      extraParams={extraParams}
      responseMapper={responseMapper}
      loadBySearch={true}
    />
  )
}
